function randomFromInterval(min, max) {
  return Math.random() * (max - min) + min;
}

function cubicBezier(P0, P1, P2, P3, t) {
  var x = (1 - t) ** 3 * P0[0] + 3 * (1 - t) ** 2 * t * P1[0] + 3 * (1 - t) * t ** 2 * P2[0] + t ** 3 * P3[0];
  var y = (1 - t) ** 3 * P0[1] + 3 * (1 - t) ** 2 * t * P1[1] + 3 * (1 - t) * t ** 2 * P2[1] + t ** 3 * P3[1];
  return [x, y];
}

// Generate cat mouth (W-shaped or small curve)
export function generateCatMouth(noseBottomY) {
  // Continuous parameters for mouth generation
  let mouthOpenness = randomFromInterval(0, 1);
  let mouthWidth = randomFromInterval(10, 20);
  let mouthDepth = randomFromInterval(3, 10);

  let startY = noseBottomY + randomFromInterval(1, 3);
  let mouthPoints = [];

  if (mouthOpenness > 0.7) {
    // Open mouth with small tongue (rare for cats)
    let mouthHeight = randomFromInterval(8, 14);

    // Simple open mouth
    for (let t = 0; t <= 1; t += 0.05) {
      let point = cubicBezier(
        [-mouthWidth * 0.6, startY],
        [-mouthWidth * 0.7, startY + mouthHeight * 0.4],
        [-mouthWidth * 0.5, startY + mouthHeight * 0.8],
        [0, startY + mouthHeight],
        t
      );
      mouthPoints.push(point);
    }

    for (let t = 0; t <= 1; t += 0.05) {
      let point = cubicBezier(
        [0, startY + mouthHeight],
        [mouthWidth * 0.5, startY + mouthHeight * 0.8],
        [mouthWidth * 0.7, startY + mouthHeight * 0.4],
        [mouthWidth * 0.6, startY],
        t
      );
      mouthPoints.push(point);
    }

    return { points: mouthPoints, hasTongue: false };
  } else {
    // W-shaped cat mouth (typical)
    // Left side of W
    for (let t = 0; t <= 1; t += 0.1) {
      let point = cubicBezier(
        [-mouthWidth, startY],
        [-mouthWidth * 0.7, startY + mouthDepth * 0.6],
        [-mouthWidth * 0.4, startY + mouthDepth * 0.8],
        [-mouthWidth * 0.2, startY + mouthDepth],
        t
      );
      mouthPoints.push(point);
    }

    // Middle dip of W (from left bottom to center)
    for (let t = 0; t <= 1; t += 0.1) {
      let point = cubicBezier(
        [-mouthWidth * 0.2, startY + mouthDepth],
        [-mouthWidth * 0.1, startY + mouthDepth * 0.6],
        [mouthWidth * 0.1, startY + mouthDepth * 0.6],
        [mouthWidth * 0.2, startY + mouthDepth],
        t
      );
      mouthPoints.push(point);
    }

    // Right side of W
    for (let t = 0; t <= 1; t += 0.1) {
      let point = cubicBezier(
        [mouthWidth * 0.2, startY + mouthDepth],
        [mouthWidth * 0.4, startY + mouthDepth * 0.8],
        [mouthWidth * 0.7, startY + mouthDepth * 0.6],
        [mouthWidth, startY],
        t
      );
      mouthPoints.push(point);
    }

    return { points: mouthPoints, hasTongue: false };
  }
}
